// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { useMemo, useEffect,createContext,useContext } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Link, useLocation  } from 'react-router-dom';
//import Ts from "./TS.tsx";
import {useIntl  , FormattedMessage } from 'react-intl';
import ReactGA from "react-ga4";
import Refresh from './components/refresh';
import {LoginContext,AuthContext,LoadingContext} from '../Default';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
} from 'material-react-table';
import {  colors } from '@mui/material';
//import { data, type Person } from './makeData';
import {type C2List}  from "./data/tdb_c2";
import './TS.css';
import Chip from '@mui/material/Chip';
import { MRT_Localization_JA } from 'material-react-table/locales/ja';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import {stix} from './data/tdb_c2.tsx';
import logo from '../../TIP_tate.svg';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

//import {RefreshContext} from './SearchResult';
// Google Analytics 測定 ID を入力して設定
ReactGA.initialize(process.env.REACT_APP_GA_KEY);
// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));
//export const RefreshContext = createContext();
const handleReady = () => {

};
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));
const StyledBox = styled('div')(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  height: 400,
  marginTop: theme.spacing(8),
  borderRadius: theme.shape.borderRadius,
  outline: '1px solid',
  boxShadow: '0 0 12px 8px hsla(220, 25%, 80%, 0.2)',
  backgroundImage: `url(${'/static/images/templates/templates-images/hero-light.png'})`,
  outlineColor: 'hsla(220, 25%, 80%, 0.5)',
  backgroundSize: 'cover',
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(10),
    height: 700,
  },
  ...theme.applyStyles('dark', {
    boxShadow: '0 0 24px 12px hsla(210, 100%, 25%, 0.2)',
    backgroundImage: `url(${'/static/images/templates/templates-images/hero-dark.png'})`,
    outlineColor: 'hsla(210, 100%, 80%, 0.1)',
  }),
}));
const styles = (theme: { spacing: { unit: number; }; shape: { borderRadius: any; }; breakpoints: { up: (arg0: string) => any; }; transitions: { create: (arg0: string) => any; }; }) => ({
  root: {
  },
  textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width: 200,
  },
  search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover': {
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          marginLeft: theme.spacing.unit,
          width: 'auto',
      },
  },
  searchIcon: {
      width: theme.spacing.unit * 9,
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
  },
  inputRoot: {
      color: 'inherit',
      width: '100%',
  },
  inputInput: {
      paddingTop: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 10,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          width: 120,
          '&:focus': {
              width: 200,
          },
      },
  },
});

export default function ColumnManage() {
  const intl = useIntl();
  let locale;
  if(intl.locale == "ja"){
    locale = MRT_Localization_JA
  }else{
    locale = MRT_Localization_EN
  }
  const location = useLocation();
  const [category, setCategory] = React.useState(location.state!==null&&location.state.hasOwnProperty("category") ? location.state["category"] : "0");
  const [keyword, setKeyword] = React.useState(location.state!==null&&location.state.hasOwnProperty("keyword") ? location.state["keyword"] : "");
  //const [refreshKey, setRefreshKey] = React.useState(0);
  //const [isActive, setIsActive] = useState(false);
  //const [category] = React.useState(location.state["category"]);
  //const [keyword] = React.useState(location.state["keyword"]);
  const [posts,setPosts] = React.useState<Post[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [open5, setOpen5] = React.useState(true);
  const {login,setLogain} = useContext(LoginContext);
  const {auth,setAuth} = useContext(AuthContext);
  const {loading,setLoading} = useContext(LoadingContext);
  const [reload,setReload] = React.useState(0);
  const [keyword2,setKeyword2] = React.useState(location.state!==null&&location.state.hasOwnProperty("keyword") ? location.state["keyword"] : intl.formatMessage({ id: "langID00088" }));
  const [checked1, setChecked1] = React.useState(false);
  const [checked2, setChecked2] = React.useState( false);


  // const value = {
  //   refreshKey,
  //   setRefreshKey,
  // };
  const handleChangeCheckBox1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked1(event.target.checked);
  };

  const handleChangeCheckBox2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked2(event.target.checked);
  };
  const handleChange = (event:SelectChangeEvent) => {
    setCategory(event.target.value);
    
  }
  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value);
  }
  
  const createColumn = () => {
    const cc = document.getElementById("createColumn");
    cc?.click();
    
  }
  const reloadChange = () => {
    if(keyword==""){
      setKeyword2(intl.formatMessage({ id: "langID00088" }));
    }else{
      setKeyword2(keyword);
    }
    const i = reload+1;
    setReload(i);
  }

  const params = { // 渡したいパラメータをJSON形式で書く
      category: category,
      keyword: keyword
    };
  var getParams = new URLSearchParams(params);
   // TextfieldとButtonIconを合体させたコンポーネントの作成
 const AddButton = () => {
  const addButtonClick = () => {

    // document.getElementById("demo-form").submit();
        ReactGA.event({
      category: "Search Button",
      action: "Search Button",
      label: keyword, // Optional
    });
    //const aaa = document.getElementById("sc");
    //aaa?.click();
    reloadChange();
     //setRefreshKey(old => old + 1)
  };
    return (
    <IconButton onClick={() => addButtonClick()}>
      <SearchIcon />
    </IconButton>
  );
};
  //const {refreshKey, setRefreshKey} = useContext(RefreshContext);
    const resData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_COLUMN_API_URL;
    try{
      let bodyData;
      if(keyword == ""){
      bodyData= {
      category: "8",
      keyword: keyword
    };
      }else if(keyword.indexOf("#") === 0){
        const keywordSub = keyword.replace("#","");
      bodyData= {
      category: "3",
      keyword: keywordSub
    };
      }else{
      bodyData= {
      category: "2",
      keyword: keyword
      };
      }

  var getParams = new URLSearchParams(params);
   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  var params_str = params.toString();
  setLoading(true);
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        setLoading(false);
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      setLoading(false);
      return jsondata;
    })
    .catch(error => {
      setLoading(false);
    });;
    setLoading(false);
    }catch{
      setLoading(false);
    }
};


  useEffect(() => {
    (async function () {
      var res =[];
      const data = await resData();
      for(var i in data){
        if(data[i].ver !==999999){
          if(!res.some(member => member.id === data[i].id)){
            data[i].main="main";
          }
        }else{
           data[i].temp="temp";
        }
      if(!checked1){
        if(!checked2){
          if(data[i].ver !==999999){
          if(!res.some(member => member.id === data[i].id)){
            res.push(data[i]);
          }
        }
      }else{
        if(data[i].ver ==999999){
            res.push(data[i]);
        }
      }
      }else{
        if(!checked2){
          if(data[i].ver !==999999){
            res.push(data[i]);
        }
      }else{
            res.push(data[i]);
      }
      }
      }
      setPosts(res);
      setLoading(false);
    })();
   }, [reload]);

  const columns = useMemo<MRT_ColumnDef<C2List>[]>(
    //column definitions...
    () => [
      {
        accessorKey: 'ip',
        header: '',
        size: 50,
        grow: false,
        Cell: ({ cell ,row}) => (
        <div >
           <Box noWrap="true"
        sx={{
          display: 'flex',
          position: 'sticky',
          justifyContent: 'flex-start',
        }}
        
      >
          <Box noWrap
        sx={{
          display: 'flex',
          left: '10px',
          position: 'sticky',
          width: '100%',
          marginLeft: '30px',
          justifyContent: 'flex-start'
        }}
      >
                <img
                  height={90}
                  width={90}
                  src={cell.row.original.thumbnail}
                  loading="lazy"
                />
        <Box noWrap sx={{ textAlign: 'left',marginLeft: '40px',display: 'block' }} component="span" >
          <Typography noWrap variant="h4" noWrap="true" style={{ maxWidth: '1300px' }}    sx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
   }}>
            {(() => {
                    return <Button component={Link} title={cell.row.original.title} size="small"  fullWidth noWrap sx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
   }} labelStyle={{paddingLeft: 0, paddingRight: 0}} style={{  overflow: "hidden",
  display: "block",
  mx: 'auto',height:"100%",color: 'black',fontSize: '0.8em',textOverflow: 'ellipsis',overflow: 'hidden'}} id={cell.row.original.title} to="/ColumnDetail"  state={{keyword:keyword,category:"find",table:cell.row.original,bf:"ad"}} onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Column Detail",
                      action: "Click Column Detail",
                      label: cell.row.original.title, // Optional
                    });

              }} >{cell.row.original.title}  </Button>;
            })()}
            </Typography>
          <Typography component='p' variant="h6" noWrap="true" style={{ maxWidth: '1200px',justifyContent: 'space-between'}} sx={{
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
   }} >
            {(() => {
                const tags = [];
                for(let tag in cell.row.original.tag){
                                if(tag==5){
                  tags.push(<br/>);
                }
                  tags.push(<Button component={Link}  size="small" style={{  flexWrap: 'wrap',overflowWrap:'break-word',fontSize: '1em' , color: 'black'}} id={cell.row.original.title}  onClick=
         {e => {
                // e.keyCodeは常に0になる
                setKeyword("#"+cell.row.original.tag[tag]);
                reloadChange();
                setKeyword2("#"+cell.row.original.tag[tag]);
                    ReactGA.event({
                      category: "Click Column Detail",
                      action: "Click Column Detail",
                      label: cell.row.original.title, // Optional
                    });

              }} >{"#"+cell.row.original.tag[tag]}  </Button>)
                }
                return tags;
            })()}
          </Typography>
          <Typography noWrap variant="h6" noWrap="true"  >
          グループID:{cell.row.original.id}<br/>
          ID:{cell.row.original._id}<br/>
          公開期間：{cell.row.original.start_date} ～ {cell.row.original.end_date}<br/>
          バージョン：{cell.row.original.ver==999999 ? "一時保存" :cell.row.original.ver}<br/>
          </Typography>
        </Box>
      </Box>
            <Box  bottom="0px" sx={{ justifyContent: 'flex-end',bottom:'0px',position:'relative' }}>
            <Typography variant="h6" sx={{ justifyContent: 'flex-end',bottom:'0px',position:'absolute',right: '0px' }}>
              {(() => {
                    return <Button hidden={!cell.row.original.hasOwnProperty("main")} variant="contained" component={Link}  size="small"  fullWidth  sx={{
      width:"100px"
   }} style={{alignItems: 'center',  
  display: "block",
  mx: 'auto',height:"80%",fontSize: '0.8em' }} id={cell.row.original.title} to="/ColumnDetail"  state={{keyword:keyword,category:"update",table:cell.row.original,bf:"ad"}} onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Column Detail",
                      action: "Click Column Detail",
                      label: cell.row.original.title, // Optional
                    });

              }} >編集 </Button>;
            
            })()}
            {(() => {
                    return <Button hidden={!cell.row.original.hasOwnProperty("temp")} variant="contained" component={Link}  size="small"  fullWidth  sx={{
      width:"100px"
   }} style={{alignItems: 'center',  
  display: "block",
  mx: 'auto',height:"80%",fontSize: '0.8em' }} id={cell.row.original.title} to="/ColumnDetail"  state={{keyword:keyword,category:"update",table:cell.row.original,bf:"ad"}} onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Column Detail",
                      action: "Click Column Detail",
                      label: cell.row.original.title, // Optional
                    });

              }} >編集 </Button>;
            
            })()}
              <br/>
               {(() => {
                    return <Button hidden={!cell.row.original.hasOwnProperty("main")} variant="contained" color="secondary"  component={Link}  size="small"  fullWidth  sx={{
      width:"100px"
   }} style={{alignItems: 'center',  
  display: "block",
  mx: 'auto',height:"80%",fontSize: '0.8em' }} id={cell.row.original.title} to="/ColumnDetail"  state={{keyword:keyword,category:"copy",table:cell.row.original,bf:"ad"}} onClick=
         {e => {
                // e.keyCodeは常に0になる
                    ReactGA.event({
                      category: "Click Column Detail",
                      action: "Click Column Detail",
                      label: cell.row.original.title, // Optional
                    });

              }} >複製 </Button>;
            })()}
            <br/>
              {cell.row.original.date}
            </Typography>
            </Box>
      </Box>

            </div>
        ),
      },
    ],
    [posts],
  );
  const data = posts
  const table = useMaterialReactTable({
    columns,
    data,
    defaultColumn: {
     // minSize: 1100,
    // width:"100%"
    },
    enableTopToolbar: false,
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableEditing: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    paginationDisplayMode:'pages',
    enableSorting: false,
    autosizeColumns:"none",
    localization: locale,
    initialState: {
      density: 'compact',
      pagination: { pageIndex: 0, pageSize: 10 },
    },
    muiDetailPanelProps: () => ({
    }),
    //custom expand button rotation
    muiExpandButtonProps: ({ row, table }) => ({
      onClick: () => table.setExpanded({ [row.id]: !row.getIsExpanded() }), //only 1 detail panel open at a time
      sx: {

      },
    }),
  });


  return (
    <Box noWrap
      id="hero"
      sx={(theme) => ({
        //width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    ><div className={auth ? '' : 'hidden'} style={{ visibility: auth ? "visible" : "hidden" }}>
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 0, sm: 13 },
          pb: { xs: 0, sm: 0 },
        }}
      > 
            <InputLabel htmlFor="email-hero" sx={visuallyHidden} >
            </InputLabel>
            <Container maxWidth={false}>
            <TextField
              id="email-hero"
              hiddenLabel
              fullWidth
              variant="outlined"
              placeholder={intl.formatMessage({ id: "langID00086" })}
              //value={location.state["keyword"]}
              defaultValue={keyword}
              autoComplete= 'off'
              InputProps={{ endAdornment: <AddButton /> }}
              onChange={handleChangeInput}
              sx={{ height:60}}
              onKeyDown={e => {
                // e.keyCodeは常に0になる
                if (e.key === 'Enter') {
                  // エンターキー押下時の処理
                  // document.getElementById("demo-form").submit();
                      ReactGA.event({
                      category: "Search Button",
                      action: "Search Button",
                      label: keyword, // Optional
                });
                  reloadChange();
                  //const aaa = document.getElementById("sc");
                  //aaa?.click();
                   //setRefreshKey(old => old + 1);
                }
              }}
            />
            <div>
              <FormControlLabel control={<Checkbox  />}　onChange={handleChangeCheckBox2} label="一時保存表示" />
              <FormControlLabel control={<Checkbox  />}　onChange={handleChangeCheckBox1} label="過去バージョン表示" />
            </div>
            </Container>
            <Typography
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 0.5,
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >

          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: 'auto' } }}
          ></Stack>
            <Link hidden id="sc" to={"/search?"+getParams} state={{keyword:keyword,category:category}}>テキスト</Link>
      </Container>
    <input type="hidden" name="recaptcha_response" id="recaptchaResponse"></input>
    <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
      <br/>
      <Container maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Typography variant="h5" gutterBottom>{intl.formatMessage({ id: "langID00088" })}</Typography>
        <Button variant="contained" to="/ColumnDetail" onClick={createColumn} sx={{width:"150px"}}>{intl.formatMessage({ id: "langID00088" })}</Button>
        <Link hidden id="createColumn" to={"/ColumnDetail"} state={{keyword:keyword,category:"new",bf:"ad",table:{none:"none"}}}>テキスト</Link>
      </Container>
    <MaterialReactTable noWrap table={table}   />
    </Container>
    </div>
    </Box>
  );
}